module.exports = __webpack_public_path__ + "static/media/screen-behavioral-04.d4ce3c87.jpg";